const Footer = () => {
    const currentYear = new Date().getFullYear();
    
    return (
        <footer>
            <div className="wrap">
                <ul className="social-links">
                    <li>
                        <a
                            href="https://www.facebook.com/TheNationalKidneyRegistry/"
                            target="_blank"
                            rel="noreferrer"
                            className="facebook"
                            aria-label="Follow National Kidney Registry on Facebook"
                        ></a>
                    </li>
                    <li>
                        <a
                            href="https://www.instagram.com/thenationalkidneyregistry/"
                            target="_blank"
                            rel="noreferrer"
                            className="instagram"
                            aria-label="Follow National Kidney Registry on Instagram"
                        ></a>
                    </li>
                    <li>
                        <a
                            href="https://www.youtube.com/channel/UCBZBdP9_JUWcOq-GYqzmHlQ"
                            target="_blank"
                            rel="noreferrer"
                            className="youtube"
                            aria-label="Watch National Kidney Registry on YouTube"
                        ></a>
                    </li>
                    <li>
                        <a
                            href="https://www.linkedin.com/company/national-kidney-registry/"
                            target="_blank"
                            rel="noreferrer"
                            className="linkedin"
                            aria-label="Connect with the National Kidney Registry on LinkedIn"
                        ></a>
                    </li>
                </ul>
                <div>
                    &copy;&nbsp;2019&nbsp;&ndash;&nbsp;{currentYear}{' '}
                    <a href="https://www.bestmatchcorporation.com/" target="_blank" rel="noreferrer">
                        Best Match Corporation
                    </a>{' '}
                    dba National Kidney Registry. All rights reserved.
                    <nav>
                        <div className="menu-footer-container">
                            <ul id="footer-menu" className="menu" style={{ listStyle: 'none', paddingInlineStart: 0 }}>
                                <li>
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href="https://www.kidneyregistry.com/site-map/"
                                    >
                                        Site Map
                                    </a>
                                    <span></span>
                                </li>
                                <li>
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href="https://www.kidneyregistry.com/privacy-policy/"
                                    >
                                        Privacy Policy
                                    </a>
                                    <span></span>
                                </li>
                                <li>
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href="https://www.kidneyregistry.com/accessibility-statement/"
                                    >
                                        Accessibility Statement
                                    </a>
                                    <span></span>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </footer>
    );
}

export default Footer;